import { render, staticRenderFns } from "./KBtn.vue?vue&type=template&id=f58bd94c&"
import script from "./KBtn.vue?vue&type=script&lang=ts&"
export * from "./KBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports